import React from 'react'
import { IPointList } from '../../../types/leaderboardTypes'
import { TableBodyRow } from '../../styled/Table.styled'
import RestaurantTable from '../../table/RestaurantTable'
import TextTableCell from '../../table/TextTableCell'

interface PointTransactionTableProps {
  pointList: IPointList[]
  maxHeight?: number
}

interface Column {
  id: string
  label: string
  minWidth?: string
  maxWidth?: string
  width?: string
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify'
  format?: (value: number) => string
  type?: string
}

const PointTransactionTable: React.FC<PointTransactionTableProps> = ({
  pointList,
  maxHeight,
}) => {
  const columns: readonly Column[] = [
    { id: 'date', label: 'Date', width: '170px' },
    {
      id: 'action',
      label: 'Action',
    },

    { id: 'points', label: 'Points', align: 'right' },
  ]
  return (
    <RestaurantTable
      columns={columns}
      data={pointList}
      maxHeight={maxHeight ?? 400}
      renderRow={(row, index) => (
        <TableBodyRow key={index}>
          <TextTableCell
            align="left"
            text={row?.date ? row?.date : '-'}
            maxWidth="150px"
            textVariant="subtitle2"
            sx={{ py: 1.5 }}
          />
          <TextTableCell
            align="left"
            text={row?.action ? row?.action : '-'}
            textVariant="subtitle2"
          />
          <TextTableCell
            align="right"
            text={row?.points ? row?.points : '-'}
            textVariant="subtitle2"
            color={
              Number(row?.points) < 0
                ? 'error.500'
                : Number(row?.points) > 0
                ? 'success.600'
                : 'grey.800'
            }
          />
        </TableBodyRow>
      )}
    />
  )
}

export default PointTransactionTable
